import { render, staticRenderFns } from "./QuickCartGiftCard.vue?vue&type=template&id=61a1864f&scoped=true"
import script from "./QuickCartGiftCard.vue?vue&type=script&lang=ts"
export * from "./QuickCartGiftCard.vue?vue&type=script&lang=ts"
import style0 from "./QuickCartGiftCard.vue?vue&type=style&index=0&id=61a1864f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a1864f",
  null
  
)

export default component.exports